import { Directive, ElementRef, OnChanges, inject, input } from '@angular/core';

@Directive({
  selector: '[camTestId]',
  standalone: true,
})
export class TestIdDirective implements OnChanges {
  camTestId = input.required<string>();

  private readonly _elementRef = inject(ElementRef<HTMLElement>);

  ngOnChanges(): void {
    this._elementRef.nativeElement.setAttribute('data-testid', this.camTestId());
  }
}
